// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"60d45516","455":"d8bac45b","977":"599bc0cf"}[chunkId] + ".chunk.js";
};